import mutationQuery from 'graphql/mutations/product/StockTakeNewLocationMutation.graphql';
import fragment from 'graphql/fragments/product/StockTakeNewLocationFragment.graphql';
import defaultQuery from 'graphql/queries/product/StockTakeNewLocationDefault.graphql';

const StockTakeNewLocation = {
  type: 'StockTakeNewLocation',
  title: 'Stock Take New Location',
  formTitle: 'Stock Take New Location',
  formUrl: '/Products/StockTakeNewLocation',
  update: mutationQuery,
  fragment,
  default: defaultQuery,
};

export default StockTakeNewLocation;
